export function handleError(msg: string): void {
    throw Error(msg);
}

export function isStandalone(): boolean {
    return window.self === window.top;
}
